import { apiRequestToastAsync } from "../../functions/FetchWithToast";
import {
    GET_TAG_DETAIL_BY_ID,
    UPDATE_TAG,
    CREATE_TAG,
    DELETE_TAG
} from "../Api";

export const getTagDetailById = (id) => apiRequestToastAsync({
    request_details: GET_TAG_DETAIL_BY_ID(id),
    messages: {
        loading: `Loading tag ID:${id}`,
        done: 'Tag loaded',
        error: `Error loading tag ID:${id}`
    }
});

export const deleteTagDetailById = (id) => apiRequestToastAsync({
    request_details: DELETE_TAG(id),
    messages: {
        loading: `Loading tag ID:${id}`,
        done: 'Tag deleted',
        error: `Error deleting tag ID:${id}`
    }
});

export const updateTagAction = (data) => apiRequestToastAsync({
    request_details: UPDATE_TAG(data),
    messages: {
        loading: `Saving tag ${data.name}`,
        done: `Saved ${data.name}`,
        error: `Error saving ${data.name}`
    }
});

export const createTagAction = (data) => apiRequestToastAsync({
    request_details: CREATE_TAG(data),
    messages: {
        loading: `Saving tag ${data.name}`,
        done: `Saved ${data.name}`,
        error: `Error saving ${data.name}`
    }
});